<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-footer">
              <button class="btn btn-default" @click="$emit('close')">
                Close
              </button>
          </div>
          <div class="modal-body">
            <slot name="body">
              <div class="d-flex justify-content-center">
              <div id="container" height="500"></div>
              </div>
            </slot>
          </div>
          <div class="modal-footer">
            <slot name="footer">
              <button class="btn btn-default" @click="$emit('close')">
                Close
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>


<script>
import { mapState } from "vuex";
let pdfjsLib = require("pdfjs-dist");
let pdfviewer = require("pdfjs-dist/web/pdf_viewer");

export default {
  name: "correspondence-modal",
  computed: mapState(["record"]),
  data: function() {
    return {
      correspondence: {}
    };
  },
  mounted: function() {
    this.loadCorrespondence();
  },
  methods: {
    loadCorrespondence() {
      let self = this;
      this.$store
        .dispatch("loadCorrespondence", {
          id: this.record.correspondence.doc_id
        })
        .then(response => {
          self.correspondence = response.data;
          self.loadPdf();
        });
    },
    loadPdf() {
      let container = document.getElementById("container");
      let pdfData = atob(this.correspondence.base64);
      let loadingTask = pdfjsLib.getDocument({ data: pdfData });
      pdfjsLib.GlobalWorkerOptions.workerSrc =
        "//mozilla.github.io/pdf.js/build/pdf.worker.js";
      loadingTask.promise.then(function(doc) {
        var promise = Promise.resolve();
        console.log(container);
        for (var i = 0; i < doc.numPages; i++) {
          // One-by-one load pages
          promise = promise.then(
            function(id) {
              return doc.getPage(id + 1).then(function(pdfPage) {
                // Add div with page view.
                var SCALE = 1.0;
                var pdfPageView = new pdfviewer.PDFPageView({
                  container: container,
                  id: id,
                  scale: SCALE,
                  defaultViewport: pdfPage.getViewport(SCALE),
                  textLayerFactory: new pdfviewer.DefaultTextLayerFactory(),
                  annotationLayerFactory: new pdfviewer.DefaultAnnotationLayerFactory()
                });
                // Associates the actual page with the view, and drawing it
                pdfPageView.setPdfPage(pdfPage);
                return pdfPageView.draw();
              });
            }.bind(null, i)
          );
        }
        return promise;
      });
    }
  }
};
</script>


<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 80%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
